import { useTheme } from "@emotion/react";

import type { ThemeType } from "../../global/emotion";

export const useThemeValues = () => useTheme() as ThemeType;
